import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
@pbi.Component({
    selector: 'menumange',
    templateUrl: './menumange.component.html',
    styleUrls: [
        './menumange.component.css',
    ]
})
export class MenuMangeComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: Object[];
    PageTitle: string = "Quản lý Menu";
    //#region Menu
    Title: string = "";
    ID: string = "-1";
    NodeID: string = "";
    Name: string = "";
    Data: string = "";
    Active: boolean = false;
    Action: string = "";
    LinkOrg: string = "";
    Link: string  = "";
    HinhAnh1: string = this.pb_func.NotImage;
    FileHinhAnh1: any = null;
    DelHinhAnh1: string = "";
    HinhAnh2: string = this.pb_func.NotImage;
    FileHinhAnh2: any = null;
    DelHinhAnh2: string = "";
    displayIMG: string = "";
    //#endregion Menu
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        let this_sav = this;
        this_sav.pb_func.loadScript([
            'assets/global/scripts/datatable.js',
            'assets/global/plugins/datatables/datatables.min.js',
            'assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.js',
            'assets/global/plugins/jstree/dist/jstree.min.js',
            'assets/pages/scripts/ui-tree.min.js',
            'assets/global/plugins/jquery-inputmask/jquery.inputmask.bundle.min.js',
            'assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js',
            'assets/more/script/fixHeightContent.js'
        ], 'menumange', function () {
            this_sav.tableMenu();
            this_sav.TreeViewHinhAnh();
        });
    };

    tableMenu() {
        let this_sav = this;
        let url = this_sav.pb_func.getBaseUrl() + "api/Menu/load";
        let table = $('#datatable_ajax');
        
        let tbl = table.DataTable({
            "bProcessing": true,
            "bServerSide": true,
            "sAjaxSource": url,
            "bSort" : false,
            "fnServerData": function (sSource, aoData, fnCallback, oSettings) {
                oSettings.jqXHR = $.ajax({
                    "dataType": 'json',
                    "type": "POST",
                    "url": sSource,
                    "data": aoData,
                    "headers": { 'Authorization': this_sav.pb_func.getToken() },
                    "success": function(json) {
                        this_sav.items = json.aaData;
                        if (this_sav.items.length > 0) {
                            this_sav.LinkOrg = this_sav.items[0]["LinkOrg"];
                        }
                        fnCallback(json);
                    },
                });
            },
            "columns": [
                { "data": null },
                { "data": "Name", "className": "dt-center" },
                { "data": "Data", "className": "dt-center" },
                { "data": "Created", "className": "dt-center" },
                { "data": "Updated", "className": "dt-center" },
                { "data": "Active", "className": "dt-center" },
                { "data": "Action", "className": "dt-center" }
            ],
            "lengthMenu": [
                [5],
                [5]
            ],
            "pageLength": 5,
            "drawCallback": function (settings) {
                $('.EditMenuModal').off('click');
                $('.EditMenuModal').click(function () {
                    this_sav.EditMenuModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
                
                $('.EditHinhAnhModal').off('click');
                $('.EditHinhAnhModal').click(function () {
                    this_sav.EditHinhAnhModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });

                $('.ActiveMenuModal').off('click');
                $('.ActiveMenuModal').click(function () {
                    this_sav.Active = $(this).prop('checked');
                    this_sav.ID = $(this).attr('idsp');
                    this_sav.UpdateMenu(this, $(this).attr('typesp'));
                });
            },
            "rowCallback": function (row, data, displayNum, displayIndex, dataIndex) {
                var page = this.fnPagingInfo().iPage;
                var length = this.fnPagingInfo().iLength;
                var index = (page * length + (displayIndex + 1));
                $('td:eq(0)', row).html(index);
            },
            "initComplete": function (settings, json) {
                this_sav.adminService.closeLoading(() => {

                });
            }
        });
    }

    //#region Modal
    EditMenuModal($event, ID: string, type: string) {
        let this_sav = this;
        let a = $event.currentTarget;
        if (type != 'add') {
            a = $event;
        }
        this_sav.ID = ID;
        
        let editModal = $('#EditMenuModal');
        if (type == "add") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            this_sav.Name = "";
            this_sav.Title = "Thêm mới Menu";
        }
        else if (type == "edit") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            let row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Title = `Sửa Menu "${this_sav.Name}"`;
        }
        else if (type == "del") {
            let row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Title = `Xóa Menu "${this_sav.Name}"`;
        }
        this_sav.Action = type;
        this_sav.Active = false;
        $(a).next().click();
    }
    //#endregion Modal

    //#region Add, Edit, Del
    UpdateMenu($event, type: string) {
        let this_sav = this;
        let table = $('#datatable_ajax').DataTable();
        let editModal = $('#EditMenuModal');
        let a = $event.currentTarget;
        if(a == null)
            a = $event;

        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Menu/Update', 'POST',
            {
                ID: this_sav.ID, Name: this_sav.Name,
                Active: this_sav.Active, Type: type
            },
            null, function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                var elemNotify = editModal.find('.notifyModal');
                if(type == "updateActive") {
                    elemNotify = $;
                    if (status == 0) {
                        var checked = $(a).prop('checked');
                        $(a).prop('checked', checked !== true);
                    }
                }

                if (status == 0) {
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }

    DeleteMenu() {
        let this_sav = this;
        let table = $('#datatable_ajax').DataTable();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Menu/Delete', 'POST', { ID: this_sav.ID }, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                if (status == 0) {
                    $.notify(mess, { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    $.notify(mess, { globalPosition: 'bottom right', className: 'success' });
                }
                $('#DelMenuModal .close').click();
            });
        });
    }
    //#endregion Add, Edit, Del

    //#region HinhAnh
    EditHinhAnhModal($event, ID: string, type: string) {
        let this_sav = this;
        let treeView = $('#treeViewHinhAnh');
        $('#LinktreeViewHinhAnh').prop('disabled', true);
        let a = $event;
        this_sav.adminService.openLoading1();
        this_sav.ID = ID;
        let row = this_sav.items.filter(function (item) {
            return item["ID"] == ID;
        })[0];
        this_sav.Name = row["Name"];
        this_sav.HinhAnh1 = this_sav.pb_func.NotImage;
        this_sav.HinhAnh2 = this_sav.pb_func.NotImage;
        this_sav.NodeID = "";
        $(a).next().click();
        treeView.jstree(true).refresh();
    }

    TreeViewHinhAnh() {
        let this_sav = this;
        this_sav.displayIMG = "";
        let treeView = $('#treeViewHinhAnh');
        let inputTreeView = $('#LinktreeViewHinhAnh');
        let dacTinh_treeViewHinhAnh = $('#dacTinh_treeViewHinhAnh');
        let tieuDe_treeViewHinhAnh = $('#tieuDe_treeViewHinhAnh');
        let tieuDeDai_treeViewHinhAnh = $('#tieuDeDai_treeViewHinhAnh');
        let fileTreeView1 = $('#FiletreeViewHinhAnh1');
        let fileTreeView2 = $('#FiletreeViewHinhAnh2');
        let url = this_sav.pb_func.getBaseUrl() + "api/Menu/HinhAnh";
        this_sav.NodeID = "";
        treeView.jstree({
            "core": {
                "themes": {
                    "responsive": false
                },
                // so that create works
                "check_callback": true,
                'data': {
                    'url': function (node) {
                        return url;
                    },
                    'data': function (node) {
                        return { 'ID': this_sav.ID };
                    },
                    'type': 'POST',
                    'headers': { 'Authorization': this_sav.pb_func.getToken() },
                    'success': function () {
                        this_sav.adminService.closeLoading(function () { });
                    }
                }
            },
            "types": {
                "default": {
                    "icon": "fa fa-folder icon-state-warning icon-lg",
                    "max_depth": 3,
                },
                "file": {
                    "icon": "fa fa-file icon-state-warning icon-lg"
                }
            },
            "contextmenu": {
                'items' : function(node) {
                    var items = $.jstree.defaults.contextmenu.items();
                    items.ccp = false;
    
                    return items;
                }
            },
            "state": { "key": "demo3" },
            "plugins": ["contextmenu", "dnd", "state", "types"]
        });

        treeView.on('changed.jstree', function (e, data) {
            
            if (this_sav.HinhAnh1 !== "delete" || this_sav.HinhAnh2 !== "delete") 
            {
                if (data.node != null) {
                    let id = data.node.id;
                    if(this_sav.NodeID == id)
                        return;
                        
                    this_sav.NodeID = id;

                    fileTreeView1.val('');
                    fileTreeView2.val('');

                    this_sav.FileHinhAnh1 = null;
                    this_sav.FileHinhAnh2 = null;

                    if (id != 'notSelectNode') {
                        inputTreeView.prop('disabled', false);
                        dacTinh_treeViewHinhAnh.prop('disabled', false);
                        tieuDe_treeViewHinhAnh.prop('disabled', false);
                        tieuDeDai_treeViewHinhAnh.prop('disabled', false);
                        
                        let href = data.node.a_attr.href;
                        let image = data.node.a_attr.image;
                        let image2 = data.node.a_attr.image2;
                        let dactinh = data.node.a_attr.dactinh;
                        let tieude = data.node.a_attr.tieude;
                        let tieudedai = data.node.a_attr.tieudedai;
                        
                        inputTreeView.val(href);

                        dacTinh_treeViewHinhAnh.val(dactinh);
                        tieuDe_treeViewHinhAnh.val(tieude);
                        tieuDeDai_treeViewHinhAnh.val(tieudedai);

                        if (image != null && image != '') {
                            this_sav.HinhAnh1 = this_sav.LinkOrg + image;
                        }
                        else {
                            this_sav.HinhAnh1 = this_sav.pb_func.NotImage;
                        }

                        if (image2 != null && image2 != '') {
                            this_sav.HinhAnh2 = this_sav.LinkOrg + image2;
                        }
                        else {
                            this_sav.HinhAnh2 = this_sav.pb_func.NotImage;
                        }

                        if(dactinh != null) {
                            if(dactinh.startsWith('#')) {
                                console.log('dactinh', dactinh.substring(1));
                                this_sav.displayIMG = dactinh.substring(1);
                            }
                            else {
                                this_sav.displayIMG = "";
                            }
                        }
                        else {
                            this_sav.displayIMG = "";
                        }
                    }
                    else {
                        this_sav.HinhAnh1 = this_sav.pb_func.NotImage;
                        this_sav.HinhAnh2 = this_sav.pb_func.NotImage;

                        inputTreeView.val('');
                        dacTinh_treeViewHinhAnh.val('');
                        tieuDe_treeViewHinhAnh.val('');
                        tieuDeDai_treeViewHinhAnh.val('');

                        inputTreeView.prop('checked', false);
                        dacTinh_treeViewHinhAnh.prop('disabled', true);
                        tieuDe_treeViewHinhAnh.prop('disabled', true);
                        tieuDeDai_treeViewHinhAnh.prop('disabled', true);
                    }
                }
            }
            else {
                this_sav.HinhAnh1 = this_sav.pb_func.NotImage;
                this_sav.HinhAnh2 = this_sav.pb_func.NotImage;
                inputTreeView.click();
            }
        });

        treeView.on("delete_node.jstree", function (e, data) {
            this_sav.HinhAnh1 = "delete";
            this_sav.HinhAnh2 = "delete";
        });

        inputTreeView.focusout(function () {
            let nodes = treeView.jstree('get_selected', true);
            nodes[0].a_attr.href = $(this).val();
        });

        inputTreeView.keypress(function (e) {
            if (e.which == 13) {
                treeView.focus();
            }
        });

        dacTinh_treeViewHinhAnh.focusout(function () {
            let nodes = treeView.jstree('get_selected', true);
            nodes[0].a_attr.dactinh = $(this).val();
        });

        dacTinh_treeViewHinhAnh.keypress(function (e) {
            if (e.which == 13) {
                treeView.focus();
            }
        });

        tieuDe_treeViewHinhAnh.focusout(function () {
            let nodes = treeView.jstree('get_selected', true);
            nodes[0].a_attr.tieude = $(this).val();
        });

        tieuDe_treeViewHinhAnh.keypress(function (e) {
            if (e.which == 13) {
                treeView.focus();
            }
        });

        tieuDeDai_treeViewHinhAnh.focusout(function () {
            let nodes = treeView.jstree('get_selected', true);
            nodes[0].a_attr.tieudedai = $(this).val();
        });

        tieuDeDai_treeViewHinhAnh.keypress(function (e) {
            if (e.which == 13) {
                treeView.focus();
            }
        });
    }

    ChangeHinhAnh($event) {
        if ($('#LinktreeViewHinhAnh').prop('disabled') !== true) {
            let a = $event.currentTarget;
            $(a).find('input[type="file"]').click();
        }
        else {
            alert('Error');
        }
    }

    readHinhAnh1($event) {
        let this_sav = this;
        let reader = new FileReader();
        reader.onload = function (ee) {
            this_sav.HinhAnh1 = reader.result.toString();
        };

        try {
            this_sav.FileHinhAnh1 = $event.currentTarget.files[0];
            reader.readAsDataURL(this_sav.FileHinhAnh1);
        }
        catch (r) {
            this_sav.HinhAnh1 = this_sav.pb_func.NotImage;
        }
    }

    readHinhAnh2($event) {
        let this_sav = this;
        let reader = new FileReader();
        reader.onload = function (ee) {
            this_sav.HinhAnh2 = reader.result.toString();
        };

        try {
            this_sav.FileHinhAnh2 = $event.currentTarget.files[0];
            reader.readAsDataURL(this_sav.FileHinhAnh2);
        }
        catch (r) {
            this_sav.HinhAnh2 = this_sav.pb_func.NotImage;
        }
    }

    SaveHinhAnh($event) {
        let this_sav = this;
        let table = $('#datatable_ajax').DataTable();
        let treeView = $('#treeViewHinhAnh');
        let editModal = $('#EditHinhAnhModal');
        let nodes = treeView.jstree('get_selected', true);
        if (nodes.length > 0) {
            this_sav.DelHinhAnh1 = nodes[0].a_attr.image;
            this_sav.DelHinhAnh2 = nodes[0].a_attr.image2;
        }
        else {
            this_sav.DelHinhAnh1 = "";
            this_sav.DelHinhAnh2 = "";
        }

        if (this_sav.FileHinhAnh1 != null) {
            nodes[0].a_attr.image = 'NewImageLinkFor1';
        }

        if (this_sav.FileHinhAnh2 != null) {
            nodes[0].a_attr.image2 = 'NewImageLinkFor2';
        }

        let v = treeView.jstree(true).get_json('#', { flat: true })
        v.splice(0, 1);

        let formData: FormData = new FormData();
        formData.append("ID", this_sav.ID);
        formData.append("HinhAnh", JSON.stringify(v));
        formData.append("DelHinhAnh1", this_sav.DelHinhAnh1);
        formData.append("FileHinhAnh1", this_sav.FileHinhAnh1);
        formData.append("DelHinhAnh2", this_sav.DelHinhAnh2);
        formData.append("FileHinhAnh2", this_sav.FileHinhAnh2);

        this_sav.pb_func.callAPI('api/Menu/UpdateHinhAnh', 'POST', formData, null,
            function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                if (status == 0) {
                    editModal.find('.notifyModal').notify(mess.toString(), { position: 'top right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    treeView.jstree(true).refresh();
                    editModal.find('.notifyModal').notify(mess.toString(), { position: 'top right', className: 'success' });
                }
            });
    }
    //#endregion HinhAnh
}


// WEBPACK FOOTER //
// ./src/app/admin/menumange/menumange.component.ts